export const APPLY_PATCH_TOPIC = '/user/topic/patch';
/** The marker a new-page client subscribes to, to get no study diffs and follow the study events (contracts/study/README.md). */
export const PATCH_SIGNAL_TOPIC = '/topic/patch-signal';
export enum ApplyPatchMessages {
  ApplyPatch = 'ApplyPatch',
}
